import { render, staticRenderFns } from "./widget_sms_stats.vue?vue&type=template&id=4ff8fd49&"
import script from "./widget_sms_stats.vue?vue&type=script&lang=js&"
export * from "./widget_sms_stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports